import Swal, { SweetAlertType } from 'sweetalert2';

const SemanticToastClassByType = {
  error: 'lum-toast--danger',
  info: 'lum-toast--info',
  success: 'lum-toast--success',
  question: 'lum-toast--secondary',
  warning: 'lum-toast--warning',
};
const SemanticButtonClassByType = {
  error: 'lum-button--danger',
  info: 'lum-button--info',
  success: 'lum-button--success',
  question: 'lum-button--secondary',
  warning: 'lum-button--warning',
};

const _getTypeOptions = (type :SweetAlertType) => ({
  customClass: {
    popup: `lum-toast ${SemanticToastClassByType[type]}`,
    cancelButton:
      'lum-button lum-button--small lum-button--tertiary  lum-toast_button',
    confirmButton: `lum-button lum-button--small ${SemanticButtonClassByType[type]}  lum-toast_button`,
    closeButton: 'swal2-close',
  },
});

const Noti :typeof Swal & {
  error ?:typeof Swal;
  info ?:typeof Swal;
  success ?:typeof Swal;
  question ?:typeof Swal;
  warning ?:typeof Swal;
} = Swal.mixin({
  toast: true,
  position: 'top',
  timer: 4000,
  buttonsStyling: false,
  showConfirmButton: false,
  reverseButtons: true,
  customClass: {
    popup: 'lum-toast lum-toast--default',
    cancelButton:
      'lum-button lum-button--small lum-button--tertiary  lum-toast_button',
    confirmButton:
      'lum-button lum-button--small lum-button--primary  lum-toast_button',
    closeButton: 'swal2-close',
  },
});

['error', 'info', 'success', 'question', 'warning'].forEach(
  (type :SweetAlertType) => {
    Noti[type] = Noti.mixin({
      ..._getTypeOptions(type),
    });
  },
);

export default Noti;
